import AlertTriangleIcon from '@crehana/compass.icons.outline/AlertTriangle';
import { Button } from '@crehana/compass.ui/button';

import { useCourseDetailTranslation } from '../../../hooks/useCourseDetailTranslation';

type EnrollmentsCurrentCourseErrorProps = {
  onRetry?: () => void;
};

export const EnrollmentsCurrentCourseError: React.FC<
  EnrollmentsCurrentCourseErrorProps
> = ({ onRetry }) => {
  const { t } = useCourseDetailTranslation();

  return (
    <div className="tw-bg-neutral-light-200 tw-p-2 tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-1.6 tw-h-24">
      <div className="tw-bg-alert-100 tw-rounded-full tw-p-1 tw-mb-1.6 tw-border-0.4 tw-border-solid tw-border-alert-200">
        <AlertTriangleIcon
          className="tw-size-2.4 tw-text-alert-500"
          size={24}
        />
      </div>
      <h4 className="tw-font-subtitle4 tw-text-gray-800 tw-text-center tw-mb-0.8">
        {t('ENROLLMENTS_CURRENT_COURSE_ERROR_TITLE')}
      </h4>
      <p className="tw-font-body4 tw-text-neutral-light-700 tw-mb-1.6 tw-text-center">
        {t('ENROLLMENTS_CURRENT_COURSE_ERROR_DESCRIPTION')}
      </p>
      {onRetry && (
        <Button type="button" variant="primary" onClick={onRetry}>
          {t('ENROLLMENTS_CURRENT_COURSE_ERROR_BUTTON')}
        </Button>
      )}
    </div>
  );
};
